import { isNil } from 'lodash';
import { formatCurrency } from '@common/utils/formatCurrency';

type FormatCurrencyProps = {
    localeString?: string;
    maximumFractionDigits?: number;
    value?: number;
    valueIsDecimal?: boolean;
};

/**
 * @description Formats a number to a currency string using the Globalize library in a React component.
 * @param {number} value - The value to format. If the value is in a decimal format, set valueIsDecimal to true.
 * @param {number} maximumFractionDigits - The maximum number of fraction digits
 * @param {boolean} valueIsDecimal - If the value is in a decimal format. If this is false or not provided, the value is divided by 100 to convert it back to the standard currency format.
 * @param {string} localeString - The locale string to use for formatting the currency. Defaults to 'nl-nl'.
 * @example
 * FormatCurrency({ value: 1231, maximumFractionDigits: 2 }); // €12.31
 */
export function FormatCurrency({
    value,
    maximumFractionDigits,
    valueIsDecimal = false,
}: Readonly<FormatCurrencyProps>) {
    if (isNil(value)) {
        return null;
    }

    const currencyFormatterExtraOptions = maximumFractionDigits ? { maximumFractionDigits } : {};

    return <span> {formatCurrency(value, valueIsDecimal, currencyFormatterExtraOptions)} </span>;
}
